import classNames from 'classnames';
import React, { useEffect, useRef } from 'react';

import './TableCalendar.scss';

type TCells =
  | 'monday'
  | 'tuesday'
  | 'wednesday'
  | 'thursday'
  | 'friday'
  | 'saturday'
  | 'sunday';

function TableCalendar({ data, updateDataHandler, initialWorkScheduleValue }: any) {
  const drawingData = useRef({
    isMouseDown: false,
    mode: 'SELECT', // или DESELECT
  });

  const weekdays: { [key in TCells]: string } = {
    monday: 'Понедельник',
    tuesday: 'Вторник',
    wednesday: 'Среда',
    thursday: 'Четверг',
    friday: 'Пятница',
    saturday: 'Суббота',
    sunday: 'Воскресенье',
  };

  const hours = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    21, 22, 23,
  ];
  function selectCell(cell: any) {
    const { hour, weekday } = cell.dataset;

    const parsedHour = Number(hour);

    data[weekday] = data[weekday]
        .filter((item: any) => item !== parsedHour)
        .concat(parsedHour)

    updateDataHandler(data)
  }

  function deselectCell(cell: any) {
    const { hour, weekday } = cell.dataset;

    const parsedHour = Number(hour);

    data[weekday] = data[weekday].filter((item: any) => item !== parsedHour)

    updateDataHandler(data)
  }

  function toggleCell(cell: any) {
    const { mode } = drawingData.current;

    if (mode === 'SELECT') {
      selectCell(cell);
    } else if (mode === 'DESELECT') {
      deselectCell(cell);
    }
  }

  function toggleDrawingMode(cell: any) {
    const { isSelected } = cell.dataset;

    if (isSelected === 'true') {
      drawingData.current.mode = 'DESELECT';
    } else {
      drawingData.current.mode = 'SELECT';
    }
  }

  function onMouseDown(event: any) {
    drawingData.current.isMouseDown = true;

    const cell = event.currentTarget;

    toggleDrawingMode(cell);
    toggleCell(cell);
  }

  function onMouseOver(event: any) {
    if (drawingData.current.isMouseDown) {
      event.preventDefault();

      const cell = event.currentTarget;

      toggleCell(cell);
    }
  }

  useEffect(() => {
    if (Object.keys(data).length < 1) {
      data = initialWorkScheduleValue
      console.log('initialWorkScheduleValue to data', data)

      updateDataHandler(data)
    }
  }, [data]);

  useEffect(() => {
    function onMouseUp() {
      drawingData.current.isMouseDown = false;
    }
    window.addEventListener('mouseup', onMouseUp);
    return () => {
      window.removeEventListener('mouseup', onMouseUp);
    };
  }, []);

  return (
      <>
        <table className="block border p-2 rounded schedule-table text-[#64748B]">
          <thead>
          <tr>
            <th />
            {hours.map((hour) => (
                <th
                    key={hour}
                    className="schedule-table__th schedule-table__th_time"
                >
                  <div className="th_table font-medium">
                    {String(hour).length === 1 ? `0${hour}` : hour}
                  </div>
                </th>
            ))}
          </tr>
          </thead>

          <tbody>
          {Object.keys(data).length > 0 &&
            (Object.keys(weekdays) as TCells[]).map((weekday) => (
                <tr key={weekday}>
                  <th className="schedule-table__th schedule-table__th_weekday pr-1 mr-1">
                    <div className="th_table font-medium">{weekdays[weekday] + ':'}</div>
                  </th>

                  {hours.map((hour) => (
                      <td key={hour} className="schedule-table__td">
                        <button
                            type="button"
                            className={classNames('schedule-table__btn', {
                              'schedule-table__btn_active':
                                  data[weekday] && data[weekday].includes(hour),
                            })}
                            onMouseDown={onMouseDown}
                            onMouseOver={onMouseOver}
                            data-hour={hour}
                            data-weekday={weekday}
                            data-is-selected={data[weekday] && data[weekday].includes(hour)}
                        />
                      </td>
                  ))}
                </tr>
            ))
          }

          </tbody>
        </table>
      </>
  );
}

export default TableCalendar;
